<template>
    <section></section>
</template>

<script>
export default {
    data() {
        return {}
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            this.GetUnit()
        })
    },
    watch: {},
    methods: {
        SetData(data) {
            data.forEach(row => {
                this.$request({
                    url: '/api_localhost/product/unit',
                    data: {
                        ...row
                    }
                })
                    .then(res => {
                        if (!res.status) {
                            window.console.log(res.data)
                        } else {
                            window.console.log('操作失败')
                        }
                    })
                    .catch(error => {
                        window.console.log(error)
                    })
            })
        },
        GetUnit() {
            this.$request({
                url: '/api/v1/unit'
            })
                .then(res => {
                    if (!res.status) {
                        this.SetData(res.data)
                    } else {
                        window.console.log('操作失败')
                    }
                })
                .catch(error => {
                    window.console.log(error)
                })
        }
    }
}
</script>

<style scoped lang="less"></style>
